import { render, staticRenderFns } from "./PDisplayContainerOrderStatus.vue?vue&type=template&id=39f6608e"
import script from "./PDisplayContainerOrderStatus.vue?vue&type=script&lang=js"
export * from "./PDisplayContainerOrderStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports